
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 185 161","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M64.57 12.21c-18.24 3.29-35.65 12-48.36 27-37.6 44.3-.85 131.9 59.47 119.64 3.74-.767 7.387-1.68 10.94-2.74a146.65 146.65 0 01-28-9.52c-74.33-33.44-37.08-106.35 5.95-134.38z","fill":"#B343E8"}}),_c('path',{attrs:{"d":"M184.77 77.67c-3.82-46.73-52.25-89.44-101-74.71a75.91 75.91 0 00-19.23 9.25c35.72-6.45 74.63 8 87.68 37.56 18.49 41.87-12 90.36-65.63 106.33 67.06 15.01 101.56-37.1 98.18-78.43z","fill":"#0BF"}}),_c('path',{attrs:{"d":"M152.25 49.77c-13-29.55-52-44-87.68-37.56-43 28-80.28 100.94-6 134.37a146.655 146.655 0 0028 9.52c53.67-15.97 84.17-64.46 65.68-106.33z","fill":"#E0FFFF"}})])
          )
        }
      }
    